import React, { useState } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";  
import "./Header.css";

const Header = () => {
    const [videoVisible, setVideoVisible] = useState(false);
    const videoId = "s77oFV9B1y4"; // ✅ Ensure this is correct

    // Custom Arrows
    const PrevArrow = ({ onClick }) => (
        <div className="absolute bottom-4 left-4 text-white text-3xl cursor-pointer z-10 bg-gray-800 p-2 rounded-full hover:bg-gray-700 transition-all duration-300" onClick={onClick}>
            <FaArrowLeft />
        </div>
    );
    const NextArrow = ({ onClick }) => (
        <div className="absolute bottom-4 right-4 text-white text-3xl cursor-pointer z-10 bg-gray-800 p-2 rounded-full hover:bg-gray-700 transition-all duration-300" onClick={onClick}>
            <FaArrowRight />
        </div>
    );

    // Slider settings
    const settings = {
        dots: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />,
    };

    return (
        <div className="w-full flex flex-col md:flex-row items-center justify-center gap-6 p-6">
            {/* Slider Section */}
            <div className="w-full md:w-2/3">
                <Slider {...settings}>
                    {/* Slide 1 */}
                    <div className="relative w-full h-[32rem] c-banner1 flex items-center">
                        <div className="container mx-auto px-12 flex items-center h-full">
                            <div className="flex flex-col items-start">
                                <h1 className="text-5xl text-neutral py-4 font-bold">
                                    <span className="text-primary">ভর্তি চলছে</span> ২০২৫-২০২৬ সেশনের বিশেষ ছাড়ে ভর্তি চলছে 
                                </h1>
                                <p className="text-xl text-neutral">Rajshahi University affiliated Engineering College</p>
                                <Link to="/single-notice">
                                    <button className="btn rounded-full my-4">Learn More</button>
                                </Link>
                            </div>
                        </div>
                    </div>

                    {/* Slide 2 */}
                    <div className="relative w-full h-[32rem] c-banner2 flex items-center">
                        <div className="container mx-auto px-12 flex items-center h-full">
                            <div className="flex flex-col items-start">
                                <h1 className="text-5xl text-neutral py-4 font-bold">
                                    সকল ডিপ্লোমা গ্রাজুয়েটদের <span className="text-primary">40% ছাড়।</span>  
                                </h1>
                                <p className="text-xl text-neutral">Rajshahi University affiliated Engineering College</p>
                                <Link to="/single-notice2">
                                    <button className="btn rounded-full my-4">Learn More</button>
                                </Link>
                            </div>
                        </div>
                    </div>

                    {/* Slide 3 */}
                    <div className="relative w-full h-[32rem] c-banner3 flex items-center">
                        <div className="container mx-auto px-12 flex items-center h-full">
                            <div className="flex flex-col items-start">
                                <h1 className="text-5xl text-neutral py-4 font-bold">
                                    <span className="text-primary">Leading</span> Private Engineering College
                                </h1>
                                <p className="text-xl text-neutral">
                                    ICE is a gateway to get an international quality public university degree to be a skilled and qualified engineer        
                                </p>
                                <Link to="/about-us">
                                    <button className="btn rounded-full my-4">Learn More</button>
                                </Link>
                            </div>
                        </div>
                    </div>

                    {/* Slide 4 */}
                    <div className="relative w-full h-[32rem] c-banner4 flex items-center">
                        <div className="container mx-auto px-12 flex items-center h-full">
                            <div className="flex flex-col items-start">
                                <h1 className="text-5xl text-neutral py-4 font-bold">
                                    The Right Choice for <span className="text-primary">Bright</span> Future
                                </h1>
                                <p className="text-xl text-neutral">Rajshahi University affiliated Engineering College</p>
                                <Link to="/about-us">
                                    <button className="btn rounded-full my-4">Learn More</button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </Slider>
            </div>

            {/* YouTube Video Section */}
            <div className="w-full md:w-1/3 lg:w-1/3 flex justify-center items-center p-4">
                <div 
                    className="relative w-full h-[16rem] md:h-[28rem] lg:h-[32rem] rounded-lg overflow-hidden shadow-xl 
                               border-4 border-primary transition-all duration-300 hover:scale-105 hover:shadow-2xl"
                >
                    {!videoVisible ? (
                        <div 
                            className="relative w-full h-full cursor-pointer"
                            onClick={() => setVideoVisible(true)}
                        >
                            {/* ✅ Fixed YouTube Thumbnail */}
                            <img 
                                src={`https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`} 
                                alt="Video Thumbnail" 
                                className="w-full h-full object-cover rounded-lg"
                                onError={(e) => e.target.src = "https://via.placeholder.com/480x270.png?text=Video+Unavailable"} // 🔥 Fallback image
                            />
                            
                            {/* Play Button */}
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="bg-black bg-opacity-50 p-4 rounded-full">
                                    <svg className="w-16 h-16 text-white" fill="currentColor" viewBox="0 0 24 24">
                                        <path d="M8 5v14l11-7z"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <iframe
                            className="w-full h-full rounded-lg"
                            src={`https://www.youtube.com/embed/${videoId}?autoplay=1&mute=0`} // ✅ Autoplay & Mute
                            title="YouTube Video"
                            frameBorder="0"
                            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture"
                            allowFullScreen
                        ></iframe>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Header;
 